import { Link } from "@at/design-system-elements";
import styled from "styled-components";

export const LearnMoreCommissionsLink = styled(Link)`
  width: max-content;
`;
